import { memo } from "react";
import { Badge } from "@/shared/components/ui/badge";
import type { InvoiceStatus } from "../types/invoice.types";

const STATUS_LABEL: Record<InvoiceStatus, string> = {
  PENDING: "Pendente",
  ISSUED: "Emitida",
  ERROR: "Erro",
  WAITING: "Aguardando",
  CANCELED: "Cancelada",
  EMISSION_DISABLED: "Emissão desativada",
  EMISSION_SKIPPED: "Emissão não solicitada",
};

const STATUS_CLASSES: Record<InvoiceStatus, string> = {
  ISSUED: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  PENDING: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  WAITING: "bg-sky-500/15 text-sky-400 border-sky-500/30",
  ERROR: "bg-rose-500/15 text-rose-400 border-rose-500/30",
  CANCELED: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
  EMISSION_DISABLED: "bg-violet-500/15 text-violet-400 border-violet-500/30",
  EMISSION_SKIPPED: "bg-orange-500/15 text-orange-400 border-orange-500/30",
};

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
}

export const InvoiceStatusBadge = memo(function InvoiceStatusBadge({
  status,
}: InvoiceStatusBadgeProps) {
  return (
    <Badge variant="outline" className={STATUS_CLASSES[status]}>
      {STATUS_LABEL[status]}
    </Badge>
  );
});

export const INVOICE_STATUS_LABELS = STATUS_LABEL;
